import "../../style/pages/Home.scss";
import { ItSolutions } from "./Solutions";
import NavPicRect from "../components/NavPicRect";

export default function Home() {
  return (
    <div className="panel-page home-page">
      <title>Home - Topassist</title>
      <meta
        name="description"
        content="Professionele verzorging en beveilig van al uw werkplekken!"
      />
      <div className="eye-catcher-container">
        <video autoPlay playsInline loop muted>
          <source src="/asset/background.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="content">
        <div className="panel over-eye-catcher objective">
          <h1>
            Onze <span className="accented">missie</span>
          </h1>
          <p>
            Wij geloven dat onze klanten en alle bedrijven voordeel kunnen halen
            uit een digitale toekomst. Wij helpen hierbij invulling te geven
            door gebruikersvriendelijke en flexibele oplossingen op ICT gebied
            te bieden waarmee overal en altijd efficiënter en productiever
            gewerkt kan worden.
          </p>
          <h1>
            Onze <span className="accented">visie</span>
          </h1>
          <p>
            Ondersteunen van bedrijven in het maken van de juiste keuzes op het
            gebied van ICT. Bij het bedrijf van de klant passende ICT
            oplossingen implementeren en beheren. We zorgen voor een veilige,
            snelle en stabiele werkomgeving. Een interactieve werkplek waarin
            prettig en productief gewerkt kan worden.
          </p>
        </div>
        <div className="panel">
          <h1>
            Digitale <span className="accented">veiligheid</span> checklist
          </h1>
          <video
            style={{ width: "100%", borderRadius: ".5rem" }}
            preload="none"
            poster="/asset/topassist-beveiligd-poster.png"
            controls
          >
            <source src="/asset/topassist-beveiligd.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="panel it-solutions">
          <h1>
            <span className="accented">iT</span>-oplossingen
          </h1>
          <h3>
            Een paar services die wij bieden vind je hieronder, druk op een knop
            om meer informatie te zien.
          </h3>
          <div className="icons">
            {ItSolutions.map((s, i) => (
              <NavPicRect
                to={`/it-oplossingen?opened=${i}`}
                imgFilename={s.imgFilename}
                imgAlt="IT-solution"
                text={s.title}
                key={s.title}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
